import { FC, ReactNode } from 'react';

import cn from 'classnames';

import s from './ShellSlideOutSidebar.module.scss';

interface IShellSlideOutSidebarProps {
  isOpen: boolean;
  children: ReactNode;
}

export const ShellSlideOutSidebar: FC<IShellSlideOutSidebarProps> = ({
  isOpen,
  children,
}) => (
  <aside
    className={cn(
      s.ssShellSlideOutSidebar,
      isOpen && s.ssShellSlideOutSidebar_open
    )}
    aria-hidden={!isOpen}
    data-testid="ss-shell-slide-out-sidebar"
  >
    {children}
  </aside>
);
